import React from 'react';

const Type = ({ type }) => (<div style={{
    display: "inline-block",
    background: "#d3d3d3",
    padding: "5px",
    borderRadius: "3px",
    marginRight: "7px"
}}>
    {type}
</div>);

export default Type;


// WEBPACK FOOTER //
// ./src/scenes/BidderSources/components/Table/components/Row/components/Type/index.js